import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";

export default function Foreigner({ foreigner = {}, convertDateTime }) {
  const {
    DispatchCompany,
    AppointFromDate,
    AppointToDate,
    ReturnDate,
    VisaExpireDate,
    VisaNo,
    VisaNoFirstTime,
    VisaNoSecondTime,
    VisaNoThirdTime,
    VisaFirstExpiredDate,
    VisaSecondExpiredDate,
    VisaThirdExpiredDate,
    IsVisaFirstTime,
    IsVisaSecondTime,
    IsVisaThirdTime,
    WorkPermitNo,
    WorkPermitFromDate,
    WorkPermitExpiredDate,
    IsWorkPermitFirstTime,
    IsWorkPermitSecondTime,
    IsWorkPermitThirdTime,
    WorkPermitNoFirst,
    WorkPermitNoSecond,
    WorkPermitNoThird,
    WorkPermitFirstExpired,
    WorkPermitSecondExpired,
    WorkPermitThirdExpired,
    TempResidenceNo,
    TempResidenceEffectDate,
    TempResidenceExpireDate,
    PerAddressAtViet,
    PhoneNumberInCountry,
    ContactPerson,
    Relationship,
  } = foreigner;
  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Dispatch Company</div>
            <div className="form-value">
              <span>{DispatchCompany}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Appoint From Date</div>
            <div className="form-value">
              <span>{convertDateTime(AppointFromDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Visa No</div>
            <div className="form-value">
              <span>{VisaNo}</span>
            </div>
          </div>
          <CheckBox
            defaultValue={IsVisaFirstTime}
            text="1st Visa Extension"
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsVisaSecondTime}
            text="2nd Visa Extension"
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsVisaThirdTime}
            text="3rd Visa Extension"
            readOnly={true}
            className="mb-2"
          />
          <br />
          <div className="form-group">
            <div className="form-label">Work Permit No</div>
            <div className="form-value">
              <span>{WorkPermitNo}</span>
            </div>
          </div>
          <CheckBox
            defaultValue={IsWorkPermitFirstTime}
            text="1st Work Permit Extension"
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsWorkPermitSecondTime}
            text="2nd Work Permit Extension"
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsWorkPermitThirdTime}
            text="3rd Work Permit Extension"
            readOnly={true}
            className="mb-2"
          />
          <br />
          <div className="form-group">
            <div className="form-label">Temp Residence No</div>
            <div className="form-value">
              <span>{TempResidenceNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Per Address At Vietnam</div>
            <div className="form-value">
              <span>{PerAddressAtViet}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Contact Person</div>
            <div className="form-value">
              <span>{ContactPerson}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Appoint To Date</div>
            <div className="form-value">
              <span>{convertDateTime(AppointToDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Visa Issue Date</div>
            <div className="form-value">
              <span>Chưa có trong DB</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">1st Visa No</div>
            <div className="form-value">
              <span>{VisaNoFirstTime}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">2nd Visa No</div>
            <div className="form-value">
              <span>{VisaNoSecondTime}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">3rd Visa No</div>
            <div className="form-value">
              <span>{VisaNoThirdTime}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Work Permit From Date</div>
            <div className="form-value">
              <span>{convertDateTime(WorkPermitFromDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">1st Work Permit No</div>
            <div className="form-value">
              <span>{WorkPermitNoFirst}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">2nd Work Permit No</div>
            <div className="form-value">
              <span>{WorkPermitNoSecond}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">3rd Work Permit No</div>
            <div className="form-value">
              <span>{WorkPermitNoThird}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Temp Residence Effect Date</div>
            <div className="form-value">
              <span>{convertDateTime(TempResidenceEffectDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Phone Number In Country</div>
            <div className="form-value">
              <span>{PhoneNumberInCountry}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Relationship</div>
            <div className="form-value">
              <span>{Relationship}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Return Date</div>
            <div className="form-value">
              <span>{convertDateTime(ReturnDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Visa expiration date</div>
            <div className="form-value">
              <span>{convertDateTime(VisaExpireDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">1st visa expiration date</div>
            <div className="form-value">
              <span>{convertDateTime(VisaFirstExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">2nd visa expiration date</div>
            <div className="form-value">
              <span>{convertDateTime(VisaSecondExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">3rd visa expiration date</div>
            <div className="form-value">
              <span>{convertDateTime(VisaThirdExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Work Permit Expired Date</div>
            <div className="form-value">
              <span>{convertDateTime(WorkPermitExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">1st Work Permit Expired</div>
            <div className="form-value">
              <span>{convertDateTime(WorkPermitFirstExpired)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">2nd Work Permit Expired</div>
            <div className="form-value">
              <span>{convertDateTime(WorkPermitSecondExpired)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">3rd Work Permit Expired</div>
            <div className="form-value">
              <span>{convertDateTime(WorkPermitThirdExpired)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Temp Residence Expired</div>
            <div className="form-value">
              <span>{convertDateTime(TempResidenceExpireDate)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
